export class GeoLayer {

    constructor(geoSection, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.name = data.name ?? null;
        this.geoSection = geoSection ?? null;
        this.geoType = data.geoType ?? null;
        this.elevationTop = data.elevationTop ?? null;
        this.elevationBottom = data.elevationBottom ?? null;
        this.verticalLevelTop = data.verticalLevelTop ?? null;
        this.verticalLevelBottom = data.verticalLevelBottom ?? null;
        this.thickness = data.thickness ?? null;
        this.notes = data.notes ?? null;

    }

    get elevationOfZeroDatumLevel() {
        return this.geoSection?.elevationOfZeroDatumLevel ?? null;
    }

}
